module.exports = __webpack_public_path__ + "media/images/bf-online-logo-fr-a763083d00d21c45f45b5ec077962535.svg";